import InlineToast from '@/components/toasts/inline';
import { Box } from '@mui/material';
import { FC } from 'react';

type Variant = 'default' | 'acl';

interface Props {
  message: string;
  variant?: Variant;
}

const AllowWarningToast: FC<Props> = ({ message, variant = 'default' }) => {
  const styleProps = variant === 'acl' ? { mt: 1, mb: 3 } : { mt: 2 };

  return (
    <Box {...styleProps}>
      <InlineToast level="warning" message={message} />
    </Box>
  );
};

export default AllowWarningToast;
